import * as React from 'react'
import * as ReactGA from 'react-ga'
import { ActivitySlide } from '../common/activity_slide/activity_slide'
import { ActivityNav } from '../common/activity_nav/activity_nav'
import { ActivityInfo } from '../common/activity_info/activity_info'
import { TabBar } from '../common/tab_bar/tab_bar'
import { Search } from './search/search'
import { List } from './list/list'

import './activity_detail.scss'
import DefaultAvatarIcon from '../../images/default_avatar.png'

import { WXShareConfig } from 'src/utils/config'
import { Api as CommonApi } from '../common/api'
import { Api } from './api'
import { Format } from './helper'
import { defaultAppFn, IShare } from '../../utils/app'
import { Observer } from '../../utils/rx'
import { IActivityNavItem } from '../common/activity_nav/interface'
import { IGetActivityInfoResponse } from '../common/interface'
import { IProps, IState, IActivityDetailRes, IActivityDetail, IActivityDetailOptionItem } from './interface'
import { IKeywordsItem } from './search/interface'

class ActivityDetail extends React.Component<IProps, IState> {
    private activityDetailOptions: IActivityDetailOptionItem[] = []
    private userInfoMap: Map<number, string> = new Map()

    constructor(props: IProps) {
        super(props)
        this.state = {
            activityNavList: [],
            activityDetail: {
                coverImage: '',
                sharePictureURL: '',
                name: '',
                brief: '',
                restVoteCount: 0,
                deadline: 0,
                searchWords: [],
                options: []
            },
            currentDetailId: 0,
            currentKeyword: '',
            isLoading: true
        }
        this.init()
    }

    public componentWillReceiveProps = () => {
        this.setState({
            currentKeyword: ''
        }, () => {
            this.init()
        })
    }

    public componentDidMount = () => {
        // 监听app分享
        Observer.subscribe('share', async () => {
            const nickname = await this.getShareNick()
            const share: IShare = {
                title: `${nickname}邀请您参加${this.state.activityDetail.name}投票，快来投我一票`,
                content: this.state.activityDetail.brief,
                image: this.state.activityDetail.coverImage,
                url: window.location.href
            }
            defaultAppFn.Apply('app_share', share)
        })
        ReactGA.pageview(window.location.pathname + window.location.search)
    }

    public componentWillUnmount = () => {
        Observer.unSubscribe('share')
    }

    public render = () => {
        const { groupId, detailId } = this.props
        const {
            activityNavList,
            activityDetail,
            currentDetailId,
            currentKeyword,
            isLoading
        } = this.state
        const {
            coverImage,
            restVoteCount,
            deadline,
            searchWords,
            options
        } = this.state.activityDetail
        return (
            <div>
                {!isLoading && <div className="activity-detail">
                    <ActivitySlide url={coverImage} />
                    <div className="activity-nav-container">
                        <ActivityNav
                            data={{
                                activityNavlist: activityNavList,
                                currentKey: currentDetailId
                            }}
                        />
                    </div>
                    <div className="activity-info-container">
                        <ActivityInfo
                            data={{
                                count: restVoteCount,
                                url: `/detail/${currentDetailId}/info`,
                                time: deadline
                            }}
                        />
                    </div>
                    <Search
                        data={{
                            keywords: searchWords,
                            'currentKeyword': currentKeyword
                        }}
                        change={this.changeSearch}
                    />
                    <div className="list-container">
                        <List
                            data={{
                                activityId: currentDetailId,
                                detail: activityDetail,
                                'options': options
                            }}
                            updateActivityDetailAndOptionItem={this.updateActivityDetailAndOptionItem}
                        />
                    </div>
                </div>}
                <TabBar data={{
                    groupId: groupId,
                    activityId: detailId,
                    currentText: '投票'
                }} />
            </div>
        )
    }

    private init = async () => {
        const { groupId, detailId } = this.props
        // 获取分组下的活动列表
        const activityNavList = await this.getGroupActivityList(Number(groupId))
        // 获取活动信息
        const getActivityInfo = await this.getActivityInfo(Number(groupId))
        // 获取活动详情
        const activityDetail = await this.getActivityDetail(Number(detailId))
        // 设置app标题
        defaultAppFn.Apply('app_nav', {
            show: true,
            back: true,
            title: activityDetail.name,
            share: true
        })
        // 微信分享设置
        WXShareConfig(
            getActivityInfo.name?`我正在参加《${getActivityInfo.name}》，快来投我一票`:`我正在参加上海有色网投票评选，快来投我一票`,
            activityDetail.brief,
            window.location.href,
            activityDetail.sharePictureURL
        )
        // 保存所有活动选项用于搜索
        this.activityDetailOptions = activityDetail.options
        // 获取用户头像
        const userIdList: number[] = []
        Array.isArray(activityDetail.options) && activityDetail.options.forEach(item => {
            Array.isArray(item.voteList) && item.voteList.forEach(voteItem => {
                const id: number = Number(voteItem)
                !Number.isNaN(id) && userIdList.push(id)
            })
        })
        userIdList.length && await this.getUserInfoList(userIdList.join(','))
        // 设置用户头像
        Array.isArray(activityDetail.options) && activityDetail.options.forEach(item => {
            Array.isArray(item.voteList) && item.voteList.forEach(voteItem => {
                const id: number = Number(voteItem)
                if (Number.isNaN(id)) {
                    item.voteAvatarUrlList.push(voteItem)
                } else {
                    item.voteAvatarUrlList.push(this.userInfoMap.get(id) || DefaultAvatarIcon)
                }
            })
        })
        this.setState({
            activityNavList: activityNavList,
            activityDetail: activityDetail,
            currentDetailId: Number(detailId),
            isLoading: false
        })
    }

    private getGroupActivityList = (id: number): Promise<IActivityNavItem[]> => {
        return new Promise(resolve => {
            let activityNavList: IActivityNavItem[] = []
            Api.getGroupActivityList(id).then(res => {
                if (res.code === 0 && res.data) {
                    activityNavList = Format.groupActivityListToActivityNav(res.data, id)
                }
                resolve(activityNavList)
            })
        })
    }

    private getActivityInfo = (id: number): Promise<IGetActivityInfoResponse['list'][0]> => {
        return new Promise(resolve => {
            let info: IGetActivityInfoResponse['list'][0] = {
                name: ''
            }
            CommonApi.getActivityInfo(id).then(res => {
                if (res.code === 0 && res.data.list && res.data.list.length) {
                    info = res.data.list[0]
                }
                resolve(info)
            })
        })
    }

    private getActivityDetail = (id: number): Promise<IActivityDetail> => {
        return new Promise(resolve => {
            let activityDetail: IActivityDetail
            Api.getActivityDetail(id).then(res => {
                if (res.code !== 0 || !res.data) {
                    return
                } else {
                    activityDetail = Format.activityDetail(res.data)
                    resolve(activityDetail)
                }
            })
        })
    }

    private getUserInfoList = (ids: string) => {
        return new Promise(resolve => {
            Api.getUserInfoList(ids).then(res => {
                if (res.code === 0 && res.data && Array.isArray(res.data.infos)) {
                    res.data.infos.forEach(item => {
                        this.userInfoMap.set(item.id, item.avatar)
                    })
                }
                resolve()
            })
        })
    }

    private getShareNick = (): Promise<string> => {
        return new Promise(resolve => {
            let nickname: string = ''
            Api.getShareNick().then(res => {
                if (res.code === 0 && res.data) {
                    nickname = res.data.nick
                }
                resolve(nickname)
            })
        })
    }

    private changeSearch = (keyword: IKeywordsItem['name']) => {
        const activityDetail = this.state.activityDetail
        if (keyword) {
            const reg = new RegExp(`${keyword}`)
            activityDetail.options = this.activityDetailOptions.filter(item => {
                return item.name.match(reg)
            })
        } else {
            activityDetail.options = this.activityDetailOptions
        }
        this.setState({
            activityDetail: activityDetail,
            currentKeyword: keyword
        })
    }

    private updateActivityDetailAndOptionItem = async (res: IActivityDetailRes) => {
        // 所有option
        const { options } = this.state.activityDetail
        // 需要更新的一项option
        let activityDetail: IActivityDetail
        activityDetail = Format.activityDetail(res)
        const updateOptionItem = activityDetail.options[0]
        if (updateOptionItem) {
            // 从所有option中更新option的一项
            for (const i in options) {
                if (options[i].id === updateOptionItem.id) {
                    // 获取用户头像
                    const userIdList: number[] = []
                    Array.isArray(updateOptionItem.voteList) && updateOptionItem.voteList.forEach(voteItem => {
                        const id: number = Number(voteItem)
                        !Number.isNaN(id) && userIdList.push(id)
                    })
                    userIdList.length && await this.getUserInfoList(userIdList.join(','))
                    // 设置用户头像
                    Array.isArray(updateOptionItem.voteList) && updateOptionItem.voteList.forEach(voteItem => {
                        const id: number = Number(voteItem)
                        if (Number.isNaN(id)) {
                            updateOptionItem.voteAvatarUrlList.push(voteItem)
                        } else {
                            updateOptionItem.voteAvatarUrlList.push(this.userInfoMap.get(id) || DefaultAvatarIcon)
                        }
                    })
                    options[i] = updateOptionItem
                    break
                }
            }
        }
        // 把更新后的option传入
        activityDetail.options = options
        this.setState({
            activityDetail: activityDetail
        })
    }
}

export {
    ActivityDetail
}


// WEBPACK FOOTER //
// ./src/components/activity_detail/activity_detail.tsx